<template>
  <div class="modal" @keydown.esc="$emit('close')">
    <div class="modal-content">
      <form @submit.prevent="saveTimeslot">
        <div class="modal-header">
          <h1>Edit timeslot</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close')"
                  aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control" id="name" v-model="timeslotData.name" ref="nameInput" required
                   placeholder="Timeslot name"/>
          </div>
          <div class="mb-3">
            <label for="quantity" class="form-label">Quantity</label>
            <input type="number" class="form-control" id="quantity" v-model="timeslotData.quantity" required
                   placeholder="Number of crew members needed" ref="quantityInput"/>
          </div>


          <div class="mb-3">
            <label for="position" class="form-label">Function</label>
            <div v-for="thisFunction in functions" :key="thisFunction.id" class="form-check">
              <input class="form-check-input" type="radio" :id="'function-' + thisFunction.id" :value="thisFunction.id"
                     v-model="timeslotData.function_id" required>
              <label class="form-check-label" :for="'function-' + thisFunction.id">{{ thisFunction.code }}</label>
            </div>
          </div>


          <div class="mb-3">
            <label for="start_datetime" class="form-label">Start date and time</label>
            <input type="datetime-local" class="form-control" id="start_datetime" v-model="timeslotData.start"
                   required
                   placeholder="Shift start date and time"/>
          </div>

          <div class="mb-3">
            <label for="end_datetime" class="form-label">End date and time</label>
            <input type="datetime-local" class="form-control" id="end_datetime" v-model="timeslotData.end" required
                   placeholder="Shift end date and time"/>
          </div>

          <p class="text-info font-weight-bold">Timeslot length: {{ shiftLength() }} hours</p>

          <div class="mb-3">
            <label for="default_slot_length" class="form-label">Default slot length (HH:MM)</label>
            <input type="text" class="form-control" id="default_slot_length" v-model="timeslotData.default_slot_length"
                   placeholder="HH:MM"/>
          </div>


        </div>
      </form>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Cancel</button>
        <button type="button" class="btn btn-primary" @click="saveTimeslot"
                :disabled="isSaveButtonDisabled">Save timeslot
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: 'EditTimeslotModal',
  props: {
    timeslot: {
      type: Object,
      required: true,
    },
    functions: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.$refs.nameInput.focus();
    this.initializeTimeslotData();
  },
  data() {
    // data() is only called once when the component is created.
    return {
      timeslotData: {
        ...this.timeslot,
        function_id: this.timeslot.function.id,
        start: this.formatDateTimeToLocal(this.timeslot.start),
        end: this.formatDateTimeToLocal(this.timeslot.end),
        default_slot_length: this.timeslot.default_slot_length || '',
      },
    };
  },
  computed: {
    isSaveButtonDisabled() {
      return this.timeslotData.name === '' ||
          this.timeslotData.quantity === '' ||
          this.timeslotData.function_id === null ||
          this.timeslotData.start === '' ||
          this.timeslotData.end === '';
    },
  },
  methods: {
    initializeTimeslotData() {
      this.timeslotData = {
        ...this.timeslot,
        function_id: this.timeslot.function.id,
        start: this.formatDateTimeToLocal(this.timeslot.start),
        end: this.formatDateTimeToLocal(this.timeslot.end),
        default_slot_length: this.formatDuration(this.timeslotData.default_slot_length),
      };
    },
    formatDateTimeToLocal(dateTime) {
      return dayjs.utc(dateTime).local().format('YYYY-MM-DDTHH:mm');
    },
    formatDuration(duration) {
      // Convert the HH:MM:SS format (retrieved from the back-end) to HH:MM format
      const [hours, minutes] = duration.split(':');
      return `${hours}:${minutes}`;
    },
    parseDuration(duration) {
      // Convert the HH:MM duration back to HH:MM:SS format before sending to the back-end
      const [hours, minutes] = duration.split(':').map(Number);
      return dayjs.duration({hours, minutes}).toISOString();
    },
    async saveTimeslot() {
      this.timeslotData.start = this.formatDateTimeToUTC(this.timeslotData.start);
      this.timeslotData.end = this.formatDateTimeToUTC(this.timeslotData.end);
      this.timeslotData.default_slot_length = this.parseDuration(this.timeslotData.default_slot_length)
      this.$emit('save-timeslot', this.timeslotData);
      this.$emit('close');
    },
    shiftLength() {
      if (this.timeslotData.start && this.timeslotData.end) {
        const start = dayjs(this.timeslotData.start);
        const end = dayjs(this.timeslotData.end);
        return dayjs.duration(end.diff(start)).asHours().toFixed(2);
      }
      return "/";
    },
    formatDateTimeToUTC(dateTime) {
      return dayjs(dateTime).utc().format();
    },

  },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>